import React from 'react'
import { User, Mail, Tag } from 'lucide-react'

class UserList extends React.Component {
  render() {
    if (!this.props.users) {
      return null
    }

    return (
      <div className="users-grid">
        {this.props.users.map(user => (
          <div
            key={user._id}
            className="user-card"
          >
            <div className="user-card-header">
              <div className="user-avatar">
                <User size={24} />
              </div>
              <div className="user-info">
                <h3 className="user-name">{user.fullname}</h3>
                <p className="user-email">
                  <Mail size={14} className="mr-1" />
                  {user.email}
                </p>
              </div>
            </div>

            <div className="user-card-body">
              <div className="user-details">
                <div className="detail-item">
                  <Tag size={14} className="mr-1" />
                  <small>
                    <strong>ID:</strong> {user.number}
                  </small>
                </div>
                <div className="detail-item">
                  <small>
                    <strong>Tipo:</strong> {user.type}
                  </small>
                </div>
                <div className="detail-item">
                  <small>
                    <strong>Categoría:</strong> {user.category || 'Sin categoría'}
                  </small>
                </div>
              </div>
            </div>

            <div className="user-card-footer">
              <span className="btn-edit" onClick={(e) => this.props.onEditUser(user, e)}>
                <i className="fas fa-edit mr-2"></i>
                Editar usuario
              </span>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export default UserList

